import { render, staticRenderFns } from "./companyInfoItem.vue?vue&type=template&id=677f522e&scoped=true"
import script from "./companyInfoItem.vue?vue&type=script&lang=js"
export * from "./companyInfoItem.vue?vue&type=script&lang=js"
import style0 from "./companyInfoItem.vue?vue&type=style&index=0&id=677f522e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677f522e",
  null
  
)

export default component.exports